<template>
  <div class="tab-item">
    <div class="cat-name">班级分类</div>
    <div id="chart-class"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";

export default {
  props: ["classCategory"],
  watch: {
    classCategory: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        this.changeChart(val);
      },
      deep: true,
      // immediate: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.drawChart(this.classCategory);
    this.changeChart(this.classCategory);
  },
  methods: {
    drawChart(data) {
      const chart = new Chart({
        container: "chart-class",
        autoFit: true,
        height: 250,
      });
      chart.data(data);
      chart.scale("num", {
        nice: true,
      });
      chart.axis("name", {
        // tickLine: null,
      });
      chart.legend(false);
      chart
        .interval()
        .position("name*num")
        .color("name", () => "#4983F5")
        .size("num", () => 20);
      chart.render();
      this.chart = chart;
    },
    changeChart(data) {
      this.chart.clear();
      this.chart.data(data);
      this.chart.scale("num", {
        nice: true,
      });
      this.chart.axis("name", {
        tickLine: null,
      });
      this.chart.legend(false);
      this.chart
        .interval()
        .position("name*num")
        .color("name", () => "#4983F5")
        .size("num", () => 20);
      this.chart.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  padding: 20px 24px;
  padding-top: 10px;
  .cat-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #343c4a;
    padding: 32px 0 24px 0;
  }
}
</style>